import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=7caaaabc&"
import script from "./monitor.vue?vue&type=script&lang=js&"
export * from "./monitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7caaaabc')) {
      api.createRecord('7caaaabc', component.options)
    } else {
      api.reload('7caaaabc', component.options)
    }
    module.hot.accept("./monitor.vue?vue&type=template&id=7caaaabc&", function () {
      api.rerender('7caaaabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/msg/monitor.vue"
export default component.exports